import { RecordType } from '../../types/api';
/**
 * Authority types sorted by MARC tag: 100, 110, 111, 130, 148, 150, 151, 155,
 * 195. OLD_PRINT_CITY (195, CZNA-181) is grouped next to GEOGRAPHIC as the
 * other place-like type.
 *
 * <p>AUTHOR_WORK (CZNA-422/CZNA-492) has no tag to sort by — its heading sits in
 * 100, 110 or 111 depending on the name portion — so it is placed next to
 * UNIFORM_TITLE, the other type that describes a work.
 *
 * <p>This is a SELECTION, not the full `RecordType` enum. Do not "complete" it
 * from the enum — add types one at a time, each with a shipped form-config.
 *
 * <p><b>CZNA-1087 — CONSPECT_GROUP is here now, and what that does and does not
 * mean.</b> It used to be absent as a hard "never created": the Konspekt set was
 * treated as closed and imported-only (CZNA-491). CZNA-1087 replaces that with
 * the rule the ticket asks for — a Konspekt record may be created, but only by
 * an NK supervisor, i.e. role × authority type. That rule is the BACKEND's:
 * `GET proposals/allowed-actions` enumerates every `RecordType` against the
 * permission matrix, `ProposalCreate` filters this list through
 * `canCreateProposalOfType`, and a type the caller may not create in is absent
 * from the answer. So membership here grants nothing; it only makes the type
 * ELIGIBLE to be offered to whoever the backend says may have it. Keeping the
 * refusal here instead would have been a second copy of an authorization rule,
 * in the one place that cannot see who is asking.
 *
 * <p>CZNA-591 — this lives in its own module rather than beside the dialog
 * because it is now read by TWO things: the dialog renders it, and
 * `ProposalCreate` filters it by permission to decide whether it has anything to
 * offer at all. While it was an export of `AuthorityTypeDialog`, any test that
 * mocked the dialog also replaced this list — so the route's filtering and the
 * test's expectation both read the stub and agreed with each other no matter
 * what the real order said. `AuthorityTypeDialog` re-exports it for the callers
 * that legitimately think of it as the dialog's contents.
 */
export var TYPE_ORDER = [
    RecordType.PERSONAL,
    RecordType.CORPORATE,
    RecordType.MEETING,
    RecordType.UNIFORM_TITLE,
    RecordType.AUTHOR_WORK,
    RecordType.CHRONOLOGICAL,
    RecordType.SUBJECT,
    RecordType.GEOGRAPHIC,
    RecordType.OLD_PRINT_CITY,
    RecordType.GENRE_FORM,
    RecordType.CONSPECT_GROUP,
];
